// extracted by mini-css-extract-plugin
export var actions = "_b-4";
export var brand = "_b-3";
export var header = "_b-0";
export var headerContent = "_b-1";
export var identity = "_b-5";
export var logo = "_b-2";